const RELOAD_STORAGE_KEY_PREFIX = 'vite-preload-error-reloaded'
let cleanupListener = null

function getReleaseIdentifier() {
  if (typeof __CI_PIPELINE_IID__ !== 'undefined' && __CI_PIPELINE_IID__) {
    return __CI_PIPELINE_IID__
  }

  const buildScript = Array.from(document.scripts).find(script => script.src.includes('/build/assets/'))

  return buildScript?.src ?? 'unknown'
}

function getReloadStorageKey() {
  return `${RELOAD_STORAGE_KEY_PREFIX}:${getReleaseIdentifier()}`
}

function isRecoverableVitePreloadError(error) {
  const message = error?.message ?? ''

  return message.includes('Unable to preload CSS')
    || message.includes('Failed to fetch dynamically imported module')
    || message.includes('Importing a module script failed')
    || message.includes('error loading dynamically imported module')
}

export function setupVitePreloadErrorReload() {
  if (cleanupListener !== null) {
    return cleanupListener
  }

  const handler = (event) => {
    if (!isRecoverableVitePreloadError(event.payload)) {
      return
    }

    event.preventDefault()

    const reloadStorageKey = getReloadStorageKey()
    if (sessionStorage.getItem(reloadStorageKey) === '1') {
      return
    }

    sessionStorage.setItem(reloadStorageKey, '1')
    window.location.reload()
  }

  window.addEventListener('vite:preloadError', handler)

  cleanupListener = () => {
    window.removeEventListener('vite:preloadError', handler)
    cleanupListener = null
  }

  return cleanupListener
}
